import {
  Component,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  DateRange,
  StatisticsParams,
  Venue,
} from '../../../../utils/CommonInterfaces';
import { RestaurantsService } from '../../../../services/restaurants.service';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgStrapiAuthConfig} from '../../../../services/strapi/auth/ng-strapi-auth-config';
@Component({
  selector: 'app-overview-view',
  templateUrl: './overview-view.component.html',
  styleUrls: ['./overview-view.component.scss'],
})
export class OverviewViewComponent implements OnChanges {
  @Input() statisticsParams: StatisticsParams;
  @Input() venueData: Venue;

  @Output() weekDaysSelectedChange = new EventEmitter<{}>();
  @Output() openSidebarEvent = new EventEmitter();

  public dateRange: DateRange;
  public weekDaysSelected: string[] = [];
  public weekDaysSelectedOld: string[] = [];
  public allVenues: Venue[] = [];
  public exportGroup: Venue[] = [];
  private apiUrl: string;
  public isDemoPos = false;
  exportInProgress = false;

  constructor(private restaurantsService: RestaurantsService,
              private httpClient: HttpClient,
              @Inject('config') private config: NgStrapiAuthConfig) {
    if (this.config && this.config.apiUrl) {
      this.apiUrl = this.config.apiUrl;
    } else {
      const err = '[NgStrapiAuth]: no api url provided';
      console.error(err);
      throw new Error('[NgStrapiAuth]: no api url provided');
    }
  }

  openRightSidebar() {
    this.openSidebarEvent.emit({});
  }

  selectionTrendsGroup($event) {
    this.exportGroup = [...$event.value];
  }

  groupByChange($event) {
    console.log('groupByChange', $event);
  }

  ngOnChanges(change: SimpleChanges): void {
    const { statisticsParams } = change;
    this.weekDaysSelected = [...this.statisticsParams.weekDaysSelected];
    this.allVenues = [...this.restaurantsService.allVenuesData];
    console.log('this.allVenues', this.allVenues);
    this.isDemoPos = '999991' === this.allVenues[0].posId;

    if (statisticsParams && statisticsParams.firstChange) {
      this.exportGroup.push(...this.allVenues);
    }

    if (statisticsParams && statisticsParams.currentValue.selectedDate) {
      const start = statisticsParams.currentValue.periodStartDate.clone();
      const end = statisticsParams.currentValue.periodEndDate.clone();

      this.dateRange = {
        start: start.format('DD/MM/YYYY'),
        end: end.format('DD/MM/YYYY'),
      };
    }
  }


}
